import React from "react";
import clsx from "clsx";

import useStyles from "./styles";

interface FormProps {
  children?: React.ReactNode;
  onSubmit: (event: React.FormEvent) => void;
  className?: string;
}

const Form = React.memo((props: FormProps) => {
  const classes = useStyles();

  const { children, onSubmit, className, ...restProps } = props;

  return (
    <form
      className={clsx(classes.root, className)}
      autoComplete="off"
      onSubmit={onSubmit}
      {...restProps}
    >
      {children}
    </form>
  );
});

export default Form;
